/* Adapter for .amp's no-store product-tag lookup. Product/catalog data stays unchanged.
   Keep this before the app embed: it evaluates the returned tags before mounting. */
(() => {
  const originalFetch = window.fetch.bind(window);
  const targetPath = /\/products\/rubber-tile-1000x1000x25\.js$/;
  const skus = new Set(['CT1000-25-GR', 'CT1000-25-BL']);
  const blockedTags = new Set(['配送希望日時指定不可', '日時指定不可']);
  window.fetch = async function(input, init) {
    const response = await originalFetch(input, init);
    const url = new URL(typeof input === 'string' ? input : input.url, location.origin);
    if (url.origin !== location.origin || !targetPath.test(url.pathname) || init?.cache !== 'no-store' || !response.ok) return response;
    try {
      const cartResponse = await originalFetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
      if (!cartResponse.ok) return response;
      const cart = await cartResponse.json();
      const count = cart.items.reduce((sum, item) => sum + (skus.has(item.sku) ? item.quantity : 0), 0);
      if (count > 10) return response;
      const product = await response.clone().json();
      if (!Array.isArray(product.tags)) return response;
      product.tags = product.tags.filter((tag) => !blockedTags.has(tag));
      const headers = new Headers(response.headers);
      headers.delete('content-length');
      headers.delete('content-encoding');
      return new Response(JSON.stringify(product), { status: response.status, statusText: response.statusText, headers });
    } catch (_) {
      // Keep the existing delivery restriction if a fresh cart cannot be verified.
      return response;
    }
  };
})();
